export default "__VITE_ASSET__CE6uLc6a__"